// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledTypography } from "@insite/mobius/Link";
import { styledTitleStyles } from "@synd/App/Components/Common/StyledTitle";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

styledTitleStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
        justify-content: center;
        flex-wrap: wrap;

        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }

        ${({ titleContentSpace, showBottomBorder }: any) => {
            if (titleContentSpace && !showBottomBorder) {
                return css`
                    margin-bottom: ${titleContentSpace}px;
                `;
            }
        }}
    `,
};

styledTitleStyles.title = {
    css: css`
        margin-bottom: 0;
        text-align: ${({ titleAlignment }: any) => titleAlignment || "left"};
        flex: 1;

        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

styledTitleStyles.divider = {
    css: css`
        flex: 0 0 100%;
        justify-content: center;

        &,
        & svg {
            width: 100%;
        }

        ${({ titleContentSpace }: any) => {
            if (titleContentSpace) {
                return css`
                    margin: 8px auto ${titleContentSpace}px auto;
                `;
            }
        }}
    `,
};

styledTitleStyles.link = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
    css: css`
        margin-left: auto;
        ${xScreen("lt", "sm")} {
            margin-left: 0;
            margin-top: 16px;
        }

        ${StyledTypography} {
            line-height: ${fontConfig.smallSingleLine.lineHeight};
        }
    `,
};
